import React from 'react';
import { ReactComponent as PropacityLogo } from '../../assets/propacityplush.svg';

const OwnerEmployeeCheck = ({ setComponentName, setIsOwner }) => {
    return (
        <>
            <div className='bg-white rounded-xl md:max-w-[560px] md:basis-[560px] pt-14 pb-8 px-6 grow-0 shrink-0 w-11/12	shadow-shadowcard'>
                <div className='w-[300px] !table mx-auto'>
                    <div className='!mx-auto !table !mb-8'><PropacityLogo /></div>

                    <div className='flex flex-col items-center justify-center'>
                        <div className='text-textblack font-semibold text-xl leading-8'>Welcome</div>
                        <div className='mt-2.5 text-sm text-black800 leading-5'>Are you a company owner or an employee?</div>
                        <button
                            className='border rounded-lg owner-btn-shadow text-center w-full !py-3 !mt-8'
                            onClick={() => {
                                setIsOwner('Owner')
                                setComponentName('signupform')
                            }}
                        >Owner</button>
                        <button
                            className='border rounded-lg owner-btn-shadow text-center w-full !py-3 mt-2.5'
                            onClick={() => {
                                setIsOwner('Employee')
                                setComponentName('signupform')
                            }}
                        >Employee</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OwnerEmployeeCheck